import React from 'react'
import { Link } from 'react-router-dom';
import { loginwithgoogle } from "./LoginWithGoogle";
import "../../design/css/login.css"

import googleIcon from "../../assets/loginimg/googleglogo.svg"
import teedexlogo from "../../assets/loginimg/teedexlogo.svg"

const MainLoginPage = () => {
	return (
		<>
		 <div className="newLoginBody">
        <div className="newLoginBodyText">
            <div className="newLoginFormContainer newLoginFormBlock">
                <h1>Login/Signup</h1>
                <p>Welcome! Please enter your details</p>
                <div class="googlelogin">
                    <a href="#" onClick={() => loginwithgoogle()} class="googleLoginButton">
                        <img src={googleIcon} alt="Google Logo" />
                        <span>Continue with Google</span>
                    </a>
                </div>
                <div className="orLogin"><span>or</span></div>
                <form>
                    <div className="inputContainer">
                        <input type="email" id="email" name="email" placeholder="Email" required />
                    </div>
                    <div className="inputContainer">
                        <button type="submit" className="loginButton">Next</button>
                    </div>
                </form>
                <div className="loginRemember">
                    <label for="rememberMe">
                        <input type="checkbox" id="rememberMe" name="rememberMe" />
                        Remember for 30 days
                    </label>
                </div>
                <div className="forgotPassword">
                    <Link to={"/Forgetpass"}>Forgot Password?</Link>
                </div>
            </div>
            <div className="formTnc newLoginFormBlock">
                By signing up for teedex you acknowledge that you agree to teedex <a href="#">Terms & Conditions</a> and <a href="#">Privacy Policy</a>
            </div>
            <div className="formTeedexLogo newLoginFormBlock">
                <img src={teedexlogo} alt="Teedex Logo" />
            </div>
            <div className="formCopyR newLoginFormBlock">© 2024 Teedex All Rights Reserved</div>
        </div>

        <div className="newLoginBodyImg"></div>
    </div>
		</>
	)
}

export default MainLoginPage